module.exports = __webpack_public_path__ + "static/media/cocon2025.cb2ded54.jpg";